<template>
  <div
    class="tw-flex tw-w-full tw-flex-col tw-items-center tw-justify-center tw-px-[16px] tw-pb-[120px] tw-pt-[16px]"
  >
    <template v-if="noHousemateData && isLoggedInStudent">
      <div
        class="tw-flex tw-w-full tw-max-w-[400px] tw-flex-col tw-items-center"
      >
        <div class="tw-aspect-[400/273] tw-w-full tw-max-w-[400px]">
          <img
            :src="cdnAsset('images/student/groups-empty.png')"
            alt=""
            loading="lazy"
            decoding="async"
            class="tw-block tw-h-full tw-w-full tw-object-contain"
          />
        </div>

        <div
          class="tw-font-inter tw-line-clamp-1 tw-self-stretch tw-overflow-hidden tw-text-ellipsis tw-py-[8px] tw-text-center tw-text-[16px] tw-font-semibold tw-leading-[150%] tw-text-[#3B4143]"
        >
          Get started by creating a group
        </div>

        <div
          class="tw-font-inter tw-pb-[24px] tw-text-center tw-text-[14px] tw-font-normal tw-leading-[150%] tw-text-[#6B7280]"
        >
          Already assembled your housemates? <br />
          Create a group to collaborate on a property shortlist and explore
          options together! Stay in the know and make important decisions as a
          team.
        </div>
      </div>

      <div
        class="tw-flex tw-w-full tw-max-w-[400px] tw-flex-col tw-items-start tw-gap-[16px]"
      >
        <button
          type="button"
          class="tw-font-inter tw-flex tw-h-[50px] tw-min-w-[343px] tw-items-center tw-justify-center tw-gap-2 tw-self-stretch tw-rounded-[30px] tw-bg-[#00A2E1] tw-px-6 tw-py-2 tw-text-center tw-text-[16px] tw-font-semibold tw-leading-[150%] tw-text-white hover:tw-bg-uhblue-700 focus-visible:tw-bg-uhblue-700 focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-[#61B3E5] focus-visible:tw-ring-offset-2"
          @click="studentStore.handleReturnToSearchPage()"
        >
          <!-- SVG-->
          <MagnifyingGlass />
          Back to search results
        </button>
        <button
          type="button"
          class="tw-font-inter tw-flex tw-h-[50px] tw-items-center tw-justify-center tw-gap-2 tw-self-stretch tw-rounded-[30px] tw-border tw-border-[#D1D5DB] tw-bg-white tw-px-6 tw-py-2 tw-text-center tw-text-[16px] tw-font-semibold tw-leading-[150%] tw-text-[#3B4143] hover:tw-border-uhblue-700 hover:tw-text-uhblue-700 focus-visible:tw-border-uhblue-700 focus-visible:tw-text-uhblue-700 focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-[#61B3E5] focus-visible:tw-ring-offset-2"
          @click="showGroupCreateModal = true"
        >
          <!-- SVG-->
          <Users />
          Create a group
        </button>
      </div>
    </template>

    <template v-else-if="!isLoggedInStudent">
      <div
        class="tw-flex tw-w-full tw-max-w-[400px] tw-flex-col tw-items-center"
      >
        <div class="tw-aspect-[400/273] tw-w-full tw-max-w-[400px]">
          <img
            :src="cdnAsset('images/student/groups-empty.png')"
            alt=""
            loading="lazy"
            decoding="async"
            class="tw-block tw-h-full tw-w-full tw-object-contain"
          />
        </div>

        <div
          class="tw-font-inter tw-line-clamp-1 tw-self-stretch tw-overflow-hidden tw-text-ellipsis tw-py-[8px] tw-text-center tw-text-[16px] tw-font-semibold tw-leading-[150%] tw-text-[#3B4143]"
        >
          You need to login or create a profile
        </div>

        <div
          class="tw-font-inter tw-pb-[24px] tw-text-center tw-text-[14px] tw-font-normal tw-leading-[150%] tw-text-[#6B7280]"
        >
          Grouplists are a way to collaborate on a property shortlist and
          explore options together! Stay in the know and make important
          decisions as a team.
        </div>
      </div>

      <div
        class="tw-flex tw-w-full tw-max-w-[400px] tw-flex-col tw-items-start"
      >
        <a
          href="/account/login"
          class="tw-mx-auto tw-flex tw-w-full tw-max-w-[328px] tw-flex-1 tw-items-center tw-justify-center tw-gap-[8px] tw-self-stretch tw-rounded-[30px] tw-bg-[#F48831] tw-px-[24px] tw-py-[8px] hover:tw-bg-[#E16B0C] focus-visible:tw-bg-[#E16B0C] focus-visible:tw-outline-none focus-visible:tw-ring-2 focus-visible:tw-ring-[#61B3E5] focus-visible:tw-ring-offset-2 disabled:tw-cursor-not-allowed disabled:tw-bg-[#efefef] disabled:hover:tw-bg-[#efefef]"
        >
          <span
            class="tw-font-inter tw-text-center tw-text-[16px] tw-font-bold tw-leading-[150%] tw-text-white"
          >
            Log in
          </span>
        </a>

        <span class="tw-mx-auto tw-mt-[16px] tw-text-[16px]">
          Don't have a profile?

          <a
            href="/account/sign-up"
            class="tw-font-[700] hover:tw-text-[#0090C8] focus-visible:tw-rounded-[2px] focus-visible:tw-text-[#0090C8] focus-visible:tw-ring-2 focus-visible:tw-ring-[#61B3E5] focus-visible:tw-ring-offset-2"
          >
            Sign up
          </a>
        </span>
      </div>
    </template>

    <!-- Housemate Group Create Modal -->
    <HousemateGroupModal
      v-if="showGroupCreateModal"
      :show="showGroupCreateModal"
      @close-modal="closeGroupCreateModal"
    >
      <template #header> Create a group </template>

      <template #body>
        <div
          class="tw-flex tw-flex-col tw-items-start tw-gap-6 tw-self-stretch tw-bg-white"
        >
          <div
            class="tw-flex tw-flex-col tw-items-start tw-gap-1 tw-self-stretch"
          >
            <div class="tw-flex tw-flex-col tw-gap-1 tw-self-stretch">
              <label
                for="groupName"
                class="tw-font-inter tw-self-stretch tw-text-base tw-font-normal tw-leading-[150%] tw-text-[#3B4143]"
              >
                Group name
              </label>
              <input
                id="groupName"
                ref="groupNameInput"
                v-model="inputGroupName"
                type="text"
                placeholder="Enter group name (optional)"
                class="tw-font-inter tw-flex tw-h-[50px] tw-items-center tw-gap-[10px] tw-self-stretch tw-rounded-lg tw-border tw-border-[#D1D5DB] tw-bg-white tw-px-4 tw-py-2 tw-text-base md:tw-w-[552px]"
                @input="studentStore.clearHousemateGroupError()"
              />
            </div>
          </div>

          <HousemateGroupLocationField
            v-model="selectedLocation"
            :cities="cities"
            :universities="allUniversities"
            placeholder="Select city or university from list"
            @update:modelValue="studentStore.clearHousemateGroupError()"
          />

          <div
            v-if="studentStore.hasGroupCreateError"
            class="tw-flex tw-font-bold tw-text-red-600"
          >
            <ul class="text-red-500 tw-mb-0">
              <li
                v-for="err in studentStore.groupCreateErrorMsg"
                :key="err"
                class="tw-list-disc"
              >
                {{ err }}
              </li>
            </ul>
          </div>
        </div>
      </template>

      <!-- Actions -->
      <template #actions>
        <button
          class="tw-font-inter tw-cursor-pointer tw-border-none tw-bg-none tw-p-0 tw-text-center tw-text-[16px] tw-font-bold tw-leading-[150%] tw-text-[#3b4143] hover:tw-text-uhblue-700 focus-visible:tw-outline-none focus-visible:tw-outline focus-visible:tw-outline-[2px] focus-visible:tw-outline-offset-[2px] focus-visible:tw-outline-[#3b414380] focus-visible:tw-ring-2 focus-visible:tw-ring-[#61B3E5]"
          type="button"
          @click="closeGroupCreateModal"
        >
          Cancel
        </button>

        <div class="tw-relative tw-inline-flex">
          <Tooltip
            :show-tool-tip="
              showToolTip && !!studentStore.hasReachedCreateGroupLimit
            "
            :can-close-tool-tip="false"
          >
            <template #body> Limit reached </template>
          </Tooltip>

          <div @click="handleShowToolTip" @mouseleave="handleCloseToolTip">
            <button
              type="button"
              :class="{
                'tw-text-[#3B4143]': disableHouseMateGroupCreation,
                'tw-text-white': !disableHouseMateGroupCreation,
                'tw-pointer-events-none':
                  !!studentStore.hasReachedCreateGroupLimit,
              }"
              class="tw-flex tw-h-[50px] tw-cursor-pointer tw-items-center tw-justify-center tw-gap-2 tw-rounded-[30px] tw-border-none tw-bg-[#f48831] tw-px-6 tw-py-2 tw-text-[14px] tw-font-semibold active:tw-opacity-90 enabled:hover:tw-bg-[#BF5209] lg:tw-text-[16px]"
              :disabled="disableHouseMateGroupCreation"
              @click="createHousemateGroup"
            >
              <!-- SVG -->
              <Users
                :fill-color="disableHouseMateGroupCreation ? '#3B4143' : '#FFF'"
              />

              Create group
            </button>
          </div>
        </div>
      </template>
      <!-- Housemate Group Create Modal -->
    </HousemateGroupModal>

    <!-- Housemate Group List Modal -->
    <HousemateGroupModal
      v-if="showGroupListModal"
      :show="showGroupListModal"
      dynamic-body-class="md:tw-py-[24px] md:tw-px-[24px] tw-px-[24px] tw-py-[16px]"
      @close-modal="closeGroupListModal"
    >
      <template #header> Choose Grouplist </template>

      <template #body>
        <Group
          v-for="groupData in studentStore.getAllPendingHousemateGroups"
          :key="groupData?.id"
          :group-data="groupData"
          @close-group-list-modal="closeGroupListModal"
        ></Group>
      </template>

      <template #actions>
        <button
          type="button"
          class="tw-font-inter tw-relative tw-cursor-pointer tw-border-none tw-bg-none tw-p-0 tw-text-center tw-text-[16px] tw-font-bold tw-leading-[150%] tw-text-[#3b4143] focus-visible:tw-outline focus-visible:tw-outline-[2px] focus-visible:tw-outline-offset-[2px] focus-visible:tw-outline-[#3b414380]"
          @click="closeGroupListModal"
        >
          Cancel
        </button>

        <div class="tw-relative tw-inline-flex">
          <Tooltip
            :show-tool-tip="
              showToolTip && !!studentStore.hasReachedCreateGroupLimit
            "
            :can-close-tool-tip="false"
          >
            <template #body> Limit reached </template>
          </Tooltip>

          <div @click="handleShowToolTip" @mouseleave="handleCloseToolTip">
            <button
              type="button"
              :class="{
                'tw-pointer-events-none':
                  !!studentStore.hasReachedCreateGroupLimit,
              }"
              class="tw-flex tw-h-[50px] tw-max-h-[50px] tw-min-w-[189px] tw-cursor-pointer tw-items-center tw-justify-center tw-gap-2 tw-rounded-[30px] tw-border tw-border-[#d1d5db] tw-bg-white tw-px-6 tw-py-2 tw-text-[16px] active:tw-opacity-90"
              :disabled="disableHouseMateGroupCreation"
              @click="
                showGroupListModal = false;
                showGroupCreateModal = true;
              "
            >
              <!-- SVG-->
              <Users />
              Create a group
            </button>
          </div>
        </div>
      </template>
    </HousemateGroupModal>
  </div>
</template>
<script>
import HousemateGroupModal from '@components/Student/Modal/HousemateGroupModal.vue';
import HousemateGroupLocationField from '@components/Student/HousemateGroupLocationDropdownField.vue';
import { useStudentStore } from '@js/stores/student/student';
import Users from '@components/Student/SVG/Users.vue';
import MagnifyingGlass from '@components/Student/SVG/MagnifyingGlass.vue';
import Tooltip from '@components/Student/Tooltip/Tooltip.vue';
import Group from '@components/Student/Group.vue';

export default {
  name: 'HousemateGroups',
  components: {
    HousemateGroupLocationField,
    Group,
    Tooltip,
    MagnifyingGlass,
    Users,
    HousemateGroupModal,
  },
  props: {
    isLoggedInStudent: {
      type: Boolean,
      default: false,
    },
    cities: {
      type: Array,
      default: () => [],
    },
    allUniversities: {
      type: Array,
      default: () => [],
    },
    universities: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    const studentStore = useStudentStore();

    return {
      studentStore,
      showGroupCreateModal: false,
      inputGroupName: studentStore.nextGroupName,
      showToolTip: false,
      showGroupListModal: false,
      hasAutoOpenedGroupList: false,
      isCreatingNewHousemateGroup: false,
      selectedLocation: null,
    };
  },
  computed: {
    noHousemateData() {
      //return !this.studentStore.housemateGroups.length;
      return (
        !this.studentStore.studentHousemateGroups.length ||
        this.studentStore.userHasOnlyPendingGroups
      );
    },
    disableHouseMateGroupCreation() {
      return (
        this.studentStore.hasReachedCreateGroupLimit ||
        this.isCreatingNewHousemateGroup
      );
    },
  },
  watch: {
    showGroupCreateModal(isVisible) {
      if (isVisible) {
        this.$nextTick(() => {
          this.$refs.groupNameInput?.focus();
        });
      }
    },
    'studentStore.userHasOnlyPendingGroups': {
      immediate: true,
      handler(hasOnlyPending) {
        if (hasOnlyPending && !this.hasAutoOpenedGroupList) {
          this.hasAutoOpenedGroupList = true;
          setTimeout(() => {
            this.showGroupListModal = true;
          }, 600);
        }
      },
    },
  },
  async mounted() {
    await this.studentStore.getHousemateGroups();
  },
  methods: {
    async createHousemateGroup() {
      this.isCreatingNewHousemateGroup = true;

      try {
        const selectedCityId = this.selectedLocation?.cityId ?? null;
        const selectedUniversityId =
          this.selectedLocation?.universityId ?? null;

        await this.studentStore.postHousemateGroup(
          this.inputGroupName,
          selectedCityId,
          selectedUniversityId
        );
        this.studentStore.setTargetHousemateGroup();
        this.isCreatingNewHousemateGroup = false;

        if (!this.studentStore.hasGroupCreateError) {
          this.showGroupCreateModal = false;
          this.inputGroupName = this.studentStore.nextGroupName;
          this.selectedLocation = null;
          this.studentStore.showHousemateGroupDetail = true;
        }
      } finally {
        this.isCreatingNewHousemateGroup = false;
      }
    },
    closeGroupCreateModal() {
      this.inputGroupName = this.studentStore.nextGroupName;
      this.selectedLocation = null;
      this.studentStore.clearHousemateGroupError();
      this.showGroupCreateModal = false;
    },
    handleShowToolTip() {
      if (!this.isCreatingNewHousemateGroup) {
        this.showToolTip = true;

        if (this.showToolTipTimeout) {
          clearTimeout(this.showToolTipTimeout);
        }

        this.showToolTipTimeout = setTimeout(
          () => (this.showToolTip = false),
          3000
        );
      }
    },
    handleCloseToolTip() {
      if (this.showToolTipTimeout) {
        clearTimeout(this.showToolTipTimeout);
      }

      this.showToolTipTimeout = setTimeout(
        () => (this.showToolTip = false),
        3000
      );
    },
    closeGroupListModal() {
      this.showGroupListModal = false;
      this.showToolTip = false;
    },
  },
};
</script>
